const MARKETING_EVENTS_ROUTES = {
    path: 'marketing-events',
    name: 'marketing-events',
    redirect: { name: 'event-list' },
    component: () => import('@/views/pages/MarketingEvents/MarketingEventsPage.vue'),
    children: [
        {
            path: 'list',
            name: 'event-list',
            meta: { transition: 'slide-left' },
            component: () => import('@/views/pages/MarketingEvents/list/EventListPage.vue')
        },
        {
            path: ':eventId',
            name: 'current-events-event',
            meta: { transition: 'slide-right' },
            // redirect: { name: 'current-event-basic' },
            component: () => import('@/views/pages/MarketingEvents/current/EventCurrentPage.vue'),
            children: [
                {
                    path: 'event',
                    name: 'current-event',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/basic/tab.tsx')
                },
                {
                    path: 'department',
                    name: 'current-event-department',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/department/tab.tsx')
                },
                {
                    path: 'distributors',
                    name: 'current-event-distributors',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/distributors/tab.tsx')
                },
                {
                    path: 'goods',
                    name: 'current-event-goods',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/goods/tab.tsx')
                },
                {
                    path: 'plan-department',
                    name: 'current-event-plan-department',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/planDepartment/tab.tsx')
                },
                {
                    path: 'attributes',
                    name: 'current-event-attributes',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/attributes/tab.tsx')
                },
                {
                    path: 'logging',
                    name: 'current-event-logging',
                    component: () => import('@/views/pages/MarketingEvents/current/tabs/logging/tab.tsx')
                }
            ]
        }
    ]
};

export default MARKETING_EVENTS_ROUTES;
